class NoImplementationAvailableError extends Error {
  constructor(feature) {
    const message = `Error, no implementation is available for: ${feature}`;
    super(message);
    this.name = 'NoImplementationAvailableError';
    this.message = message;
  }
}

export default NoImplementationAvailableError;
